const ShareRegister = {
  ShareRegisterTodoToApproveHeader: "ShareRegister.ShareRegisterTodoToApproveHeader",
  ShareRegisterTodoToApproveSubHeader: "ShareRegister.ShareRegisterTodoToApproveSubHeader",
  ShareRegisterTodoDenyLabelText: "ShareRegister.ShareRegisterTodoDenyLabelText",
  ShareRegisterTodoAttachDescriptionText: "ShareRegister.ShareRegisterTodoAttachDescriptionText",
  ShareRegisterRejectSuccessMessage: "ShareRegister.ShareRegisterRejectSuccessMessage",
  ShareRegiterApproveSuccessMessage: "ShareRegister.ShareRegiterApproveSuccessMessage",
  ShareRegisterTodoSentBackHeader: "ShareRegister.ShareRegisterTodoSentBackHeader",
  ShareRegisterTodoSentBackSubHeader: "ShareRegister.ShareRegisterTodoSentBackSubHeader",
  }
export default ShareRegister;